import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appDataActions from '../../actions/appDataActions';
import * as trackingDataActions from '../../actions/trackingDataActions';
import * as mainMenuActions from '../../actions/mainMenuActions';
import * as appHelper from '../../helpers/appHelper';
import * as actionTypes from '../../actions/actionTypes';
import {getScreenComponentByType} from '../../helpers/componentHelper';
import * as keyboardConstants from '../../constants/keyboardConstants';


class HomeButton extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            label: appHelper.getLocaleString("home_label"),
        };
        this.onHomeClick = this.onHomeClick.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                label: appHelper.getLocaleString("home_label"),
            });
        }
    }

    onHomeClick(e) {
        e.preventDefault();
        e.stopPropagation();
        this.props.closeMenu();
        this.context.router.push(`menu`);
    }

    setKeyboardAccessibility(event){
        if(event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY){
            event.preventDefault();
            this.props.closeMenu();
            this.context.router.push(`menu`);
        }
    }

    render() {
        return (
            <button className={`btn guroo-btn home-btn`} onClick={this.onHomeClick} onKeyDown={this.setKeyboardAccessibility} role="link" tabIndex="0" aria-controls="bite_menu" title={this.state.label}>{this.state.label}</button>
        );
    }
}

HomeButton.propTypes = {
    closeMenu: PropTypes.func.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired

};

HomeButton.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, mainMenuActions), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(HomeButton);



/** WEBPACK FOOTER **
 ** ./src/components/buttons/HomeButton.js
 **/